<!-- Debug info, remove in production -->
<div *ngIf="false">
  <div>Single value mode: {{ isSingleValueMode }}</div>
  <div>Value: {{ value | json }}</div>
  <div>HighValue: {{ highValue | json }}</div>
</div>

<!-- Single value slider when in single value mode -->
<ngx-slider
  *ngIf="isSingleValueMode"
  [id]="props.id"
  [options]="props.sliderOptions"
  (valueChange)="onValueChange($event)"
  [(value)]="value"
></ngx-slider>

<!-- Range slider when in range mode -->
<ngx-slider
  *ngIf="!isSingleValueMode"
  [id]="props.id"
  [options]="props.sliderOptions"
  (highValueChange)="onHighValueChange($event)"
  (userChangeEnd)="onUserChangeEnd($event)"
  (valueChange)="onValueChange($event)"
  [(highValue)]="highValue"
  [(value)]="value"
></ngx-slider>

<!-- Input fields for range mode -->
<div
  *ngIf="!isSingleValueMode && props.showInputs"
  class="inputs d-flex gap-4 justify-content-between align-content-center mt-4"
>
  <div class="form-group mb-0">
    <label [for]="props.id + '-min'">{{ "Min" | translate }}</label>
    <input [id]="props.id + '-min'" class="form-control" [(ngModel)]="value" type="number" />
  </div>
  <div class="form-group mb-0">
    <label [for]="props.id + '-max'">{{ "Max" | translate }}</label>
    <input [id]="props.id + '-max'" class="form-control" [(ngModel)]="highValue" type="number" />
  </div>
</div>

<!-- Input field for single value mode -->
<div
  *ngIf="isSingleValueMode && props.showInputs"
  class="inputs d-flex justify-content-center align-content-center mt-4"
>
  <div class="form-group mb-0">
    <label [for]="props.id + '-value'">{{ props.valueLabel || "Value" | translate }}</label>
    <input
      [id]="props.id + '-value'"
      [step]="props.sliderOptions?.step || 1"
      class="form-control"
      [(ngModel)]="value"
      type="number"
    />
  </div>
</div>
